/**
 * Comprehensive interest list for child profiles
 * 230+ interests organized by category
 */

export const ALL_INTERESTS = [
  // A
  'Acting', 'Aerobics', 'Aeronautics', 'Animation', 'Animals', 'Anthropology',
  'App Development', 'Archery', 'Archaeology', 'Art', 'Astronomy', 'Aviation',
  
  // B
  'Backpacking', 'Badminton', 'Baking', 'Ballet', 'Ballroom Dance', 'Band',
  'Baseball', 'Basketball', 'Basket Weaving', 'Beading', 'Biology', 'Bird Watching',
  'BMX', 'BMX Racing', 'Board Games', 'Bouldering', 'Bowling', 'Boxing',
  'Brazilian Jiu-Jitsu', 'Breakdancing', 'Bushcraft', 'Business',
  
  // C
  'Camping', 'Canoeing', 'Cartooning', 'Caving', 'Ceramics', 'Challenge Course',
  'Character Building', 'Cheerleading', 'Chemistry', 'Chess', 'Choir',
  'Civil Engineering', 'Clay Modeling', 'Coding', 'Comic Book Art',
  'Community Service', 'Computer Science', 'Confidence Building', 'Conservation',
  'Contemporary Dance', 'Cooking', 'Crafts', 'Creative Writing', 'Cross Country',
  'Culinary Arts', 'Cultural Studies', 'Cycling',
  
  // D
  'Dance', 'Debate', 'Digital Art', 'Diving', 'DJing', 'Dodgeball', 'Drama',
  'Drawing', 'Drones', 'Drums',
  
  // E
  'Earth Science', 'Ecology', 'Economics', 'Electrical Engineering', 'Electronics',
  'Entrepreneurship', 'Environmental Science', 'Escape Rooms', 'ESL',
  
  // F
  'Farming', 'Fencing', 'Field Hockey', 'Film Making', 'Finance', 'Fire Making',
  'Fishing', 'Flag Football', 'Football', 'Foraging', 'French', 'Friendship Building',
  
  // G
  'Game Development', 'Gardening', 'Geocaching', 'Geography', 'Geology',
  'Geometry', 'Glass Blowing', 'Golf', 'Graphic Design', 'Guitar', 'Gymnastics',
  
  // H
  'Hiking', 'Hip Hop', 'History', 'Hockey', 'Horse Care', 'Horseback Riding',
  
  // I
  'Ice Hockey', 'Ice Skating', 'Illustration', 'Improv', 'Insect Study',
  
  // J
  'Jazz Dance', 'Jewelry Making', 'Journalism', 'Judo',
  
  // K
  'Karate', 'Kayaking', 'Kickball', 'Knitting', 'Kung Fu',
  
  // L
  'Lacrosse', 'Languages', 'Leadership', 'Leadership Development', 'Lego Building',
  'Lego Robotics',
  
  // M
  'Magic', 'Marine Biology', 'Marine Life', 'Martial Arts', 'Math',
  'Math Competitions', 'Mechanical Engineering', 'Metalworking', 'Minecraft Modding',
  'Mindfulness', 'Mock Trial', 'Model Rocketry', 'Model UN', 'Motocross',
  'Mountain Biking', 'Mural Painting', 'Music', 'Music Production',
  'Musical Theater', 'Music Composition',
  
  // N
  'Nature', 'Navigation', 'Negotiation',
  
  // O
  'Orchestra', 'Orienteering', 'Origami', 'Outdoor Cooking',
  
  // P
  'Paddleboarding', 'Painting', 'Parkour', 'Pastry Making', 'Philosophy',
  'Photography', 'Physics', 'Piano', 'Pickleball', 'Pilates', 'Playwriting',
  'Poetry', 'Pottery', 'Public Speaking', 'Puppetry', 'Puzzle Solving',
  'Python Programming',
  
  // Q
  'Quilting',
  
  // R
  'Racquetball', 'Rafting', 'Ranch Work', 'Reading', 'Roblox Coding',
  'Rock Climbing', 'Robotics', 'Rocketry', 'Roller Skating', 'Ropes Course',
  'Rowing', 'Rugby', 'Running',
  
  // S
  'Sailing', 'Scrapbooking', 'Scratch Programming', 'Sculpture', 'Service Learning',
  'Sewing', 'Shelter Building', 'Shooting Sports', 'Singing', 'Skateboarding',
  'Sketching', 'Skiing', 'Snorkeling', 'Snowboarding', 'Soccer', 'Social Skills',
  'Social Studies', 'Softball', 'Songwriting', 'Space Science', 'Spanish',
  'Speech', 'Squash', 'Stage Design', 'Statistics', 'STEM', 'Stop Motion Animation',
  'Street Art', 'Student Government', 'Study Skills', 'Surfing',
  
  // T
  'Taekwondo', 'Tap Dance', 'Team Handball', 'Tennis', 'Test Prep', 'Theater',
  'Tie-Dye', 'Track & Field', 'Trail Running',
  
  // U
  'Ultimate Frisbee',
  
  // V
  'VEX Robotics', 'Video Editing', 'Videography', 'Violin', 'Volleyball',
  'Volunteer Work',
  
  // W
  'Wakeboarding', 'Water Polo', 'Water Skiing', 'Web Development',
  'Western Riding', 'Wildlife Observation', 'Wilderness Survival', 'Woodworking',
  'World Cultures', 'Wrestling', 'Writing',
  
  // Y
  'Yoga',
  
  // Z
  'Zip Lining'
];

// Export as AVAILABLE_INTERESTS for backward compatibility
export const AVAILABLE_INTERESTS = ALL_INTERESTS;

// Organized by category for browse mode
export const INTERESTS_BY_CATEGORY = {
  'Sports & Fitness': {
    icon: '🏃',
    interests: [
      'Soccer', 'Basketball', 'Volleyball', 'Baseball', 'Softball', 'Football',
      'Flag Football', 'Rugby', 'Lacrosse', 'Field Hockey', 'Ice Hockey',
      'Ultimate Frisbee', 'Tennis', 'Pickleball', 'Badminton', 'Squash',
      'Swimming', 'Diving', 'Water Polo', 'Surfing', 'Kayaking', 'Sailing',
      'Track & Field', 'Cross Country', 'Golf', 'Archery', 'Fencing',
      'Rock Climbing', 'Skateboarding', 'Martial Arts', 'Karate', 'Taekwondo',
      'Gymnastics', 'Dance', 'Cheerleading', 'Yoga', 'Running', 'Cycling',
      'BMX', 'BMX Racing', 'Bowling', 'Boxing', 'Brazilian Jiu-Jitsu',
      'Cross Country', 'Dodgeball', 'Hockey', 'Ice Skating', 'Kickball',
      'Motocross', 'Mountain Biking', 'Paddleboarding', 'Racquetball',
      'Roller Skating', 'Rowing', 'Skiing', 'Snowboarding', 'Squash',
      'Team Handball', 'Tennis', 'Trail Running', 'Ultimate Frisbee',
      'Wakeboarding', 'Water Polo', 'Water Skiing', 'Wrestling'
    ]
  },
  'Arts & Culture': {
    icon: '🎨',
    interests: [
      'Art', 'Drawing', 'Painting', 'Sketching', 'Animation', 'Digital Art',
      'Graphic Design', 'Sculpture', 'Pottery', 'Ceramics', 'Woodworking',
      'Crafts', 'Jewelry Making', 'Sewing', 'Photography', 'Film Making',
      'Drama', 'Theater', 'Acting', 'Musical Theater', 'Music', 'Piano',
      'Guitar', 'Drums', 'Singing', 'Dance', 'Ballet', 'Hip Hop',
      'Cooking', 'Baking', 'Basket Weaving', 'Beading', 'Cartooning',
      'Clay Modeling', 'Comic Book Art', 'Contemporary Dance', 'DJing',
      'Glass Blowing', 'Illustration', 'Jazz Dance', 'Knitting', 'Metalworking',
      'Mural Painting', 'Music Composition', 'Music Production', 'Origami',
      'Pastry Making', 'Playwriting', 'Poetry', 'Puppetry', 'Quilting',
      'Scrapbooking', 'Songwriting', 'Stage Design', 'Stop Motion Animation',
      'Street Art', 'Tie-Dye', 'Video Editing', 'Videography', 'Writing'
    ]
  },
  'Science & Technology': {
    icon: '🔬',
    interests: [
      'Science', 'Coding', 'Robotics', 'STEM', 'Computer Science',
      'Python Programming', 'Game Development', 'App Development', 'Web Development',
      'Lego Robotics', 'VEX Robotics', 'Drones', 'Physics', 'Chemistry',
      'Biology', 'Astronomy', 'Engineering', 'Math', 'Electronics',
      'Aeronautics', 'Anthropology', 'Archaeology', 'Astronomy', 'Aviation',
      'Biology', 'Chemistry', 'Civil Engineering', 'Computer Science',
      'Earth Science', 'Ecology', 'Economics', 'Electrical Engineering',
      'Electronics', 'Environmental Science', 'Game Development',
      'Geography', 'Geology', 'Geometry', 'Marine Biology', 'Marine Life',
      'Math', 'Math Competitions', 'Mechanical Engineering', 'Minecraft Modding',
      'Model Rocketry', 'Physics', 'Python Programming', 'Roblox Coding',
      'Robotics', 'Rocketry', 'Scratch Programming', 'Space Science',
      'Statistics', 'STEM', 'VEX Robotics'
    ]
  },
  'Outdoor & Adventure': {
    icon: '🏕️',
    interests: [
      'Hiking', 'Camping', 'Rock Climbing', 'Kayaking', 'Canoeing',
      'Fishing', 'Nature', 'Animals', 'Wildlife Observation', 'Bird Watching',
      'Gardening', 'Environmental Science', 'Horseback Riding', 'Archery',
      'Wilderness Survival', 'Geocaching', 'Mountain Biking', 'Backpacking',
      'Bouldering', 'Bushcraft', 'Caving', 'Challenge Course', 'Conservation',
      'Foraging', 'Hiking', 'Horse Care', 'Navigation', 'Orienteering',
      'Outdoor Cooking', 'Rafting', 'Ranch Work', 'Ropes Course',
      'Shelter Building', 'Snorkeling', 'Surfing', 'Trail Running',
      'Wakeboarding', 'Water Skiing', 'Western Riding', 'Zip Lining'
    ]
  },
  'Academic & Learning': {
    icon: '📚',
    interests: [
      'Reading', 'Writing', 'Creative Writing', 'Math', 'History',
      'Science', 'Languages', 'Spanish', 'French', 'Public Speaking',
      'Debate', 'Leadership', 'Geography', 'Philosophy', 'Anthropology',
      'Archaeology', 'Cultural Studies', 'Economics', 'ESL', 'History',
      'Journalism', 'Languages', 'Leadership', 'Leadership Development',
      'Mock Trial', 'Model UN', 'Philosophy', 'Public Speaking', 'Reading',
      'Social Studies', 'Spanish', 'Speech', 'Study Skills', 'Test Prep',
      'World Cultures', 'Writing'
    ]
  },
  'Specialty Programs': {
    icon: '⭐',
    interests: [
      'Social Skills', 'Leadership Development', 'Community Service',
      'Magic', 'Chess', 'Board Games', 'Lego Building', 'Character Building',
      'Confidence Building', 'Escape Rooms', 'Friendship Building',
      'Mindfulness', 'Negotiation', 'Puzzle Solving', 'Service Learning',
      'Social Skills', 'Student Government', 'Volunteer Work'
    ]
  }
};

// Related interests for matching
export const RELATED_INTERESTS = {
  'Soccer': ['Football', 'Flag Football', 'Ultimate Frisbee', 'Team Handball', 'Futsal'],
  'Basketball': ['Volleyball', 'Dodgeball', 'Team Sports'],
  'Coding': ['Robotics', 'Game Development', 'Computer Science', 'STEM', 'App Development', 'Python Programming', 'Web Development'],
  'Art': ['Drawing', 'Painting', 'Sketching', 'Crafts', 'Sculpture', 'Digital Art', 'Graphic Design'],
  'Drama': ['Theater', 'Acting', 'Musical Theater', 'Improv'],
  'Swimming': ['Diving', 'Water Polo', 'Surfing', 'Kayaking', 'Snorkeling'],
  'Music': ['Piano', 'Guitar', 'Singing', 'Band', 'Orchestra', 'Music Composition', 'Music Production'],
  'Dance': ['Ballet', 'Hip Hop', 'Jazz Dance', 'Gymnastics', 'Contemporary Dance', 'Tap Dance', 'Ballroom Dance'],
  'Science': ['Physics', 'Chemistry', 'Biology', 'STEM', 'Robotics', 'Astronomy'],
  'Reading': ['Writing', 'Creative Writing', 'Literature', 'Journalism'],
  'Nature': ['Wildlife Observation', 'Bird Watching', 'Environmental Science', 'Hiking', 'Camping'],
  'Cooking': ['Baking', 'Culinary Arts', 'Pastry Making'],
  'Ultimate Frisbee': ['Soccer', 'Football', 'Team Sports', 'Flag Football'],
  'Pickleball': ['Tennis', 'Badminton', 'Racquetball', 'Squash'],
  'Game Development': ['Coding', 'Computer Science', 'Robotics', 'STEM', 'App Development'],
  'Marine Biology': ['Marine Life', 'Biology', 'Science', 'Wildlife Observation', 'Environmental Science'],
  'Stop Motion Animation': ['Animation', 'Film Making', 'Video Editing', 'Digital Art'],
  'Rock Climbing': ['Bouldering', 'Mountaineering', 'Outdoor Adventure'],
  'Robotics': ['Coding', 'STEM', 'Engineering', 'Lego Robotics', 'VEX Robotics'],
  'Tennis': ['Pickleball', 'Badminton', 'Squash', 'Racquetball'],
  'Baseball': ['Softball', 'Sports', 'Team Sports'],
  'Football': ['Soccer', 'Flag Football', 'Ultimate Frisbee', 'Team Sports'],
  'Martial Arts': ['Karate', 'Taekwondo', 'Brazilian Jiu-Jitsu', 'Judo', 'Kung Fu'],
  'Gymnastics': ['Dance', 'Cheerleading', 'Acrobatics', 'Fitness'],
  'Photography': ['Videography', 'Film Making', 'Digital Art', 'Visual Arts'],
  'Writing': ['Creative Writing', 'Journalism', 'Poetry', 'Playwriting'],
  'Hiking': ['Backpacking', 'Camping', 'Nature', 'Outdoor Adventure'],
  'Skiing': ['Snowboarding', 'Winter Sports', 'Outdoor Adventure'],
  'Surfing': ['Wakeboarding', 'Water Skiing', 'Water Sports', 'Swimming'],
  'STEM': ['Coding', 'Robotics', 'Science', 'Computer Science', 'Engineering', 'Math', 'Physics', 'Chemistry', 'Biology', 'Game Development', 'App Development', 'Python Programming', 'Web Development', 'Lego Robotics', 'VEX Robotics'],
  'Animals': ['Nature', 'Wildlife Observation', 'Environmental Science', 'Marine Biology', 'Marine Life', 'Biology', 'Science']
};
